export enum WesterosServiceModalMode {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
